// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"18d8ce1f","850":"f6e1e792"}[chunkId] + ".chunk.js";
};